import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Radio = ({
    label,
    disabled,
    onClick,
    value,
    checked,
    ...props
}) => {
    const [isChecked, setIsChecked] = useState(checked);

    useEffect(() => {
        setIsChecked(!!checked);
    }, [checked]);

    const onChange = event => {
        event.preventDefault();
        event.stopPropagation();
        setIsChecked(!isChecked);
        onClick(event);
    };

    const handleKeyPress = event => {
        if (event.keyCode === 13) {
            setIsChecked(!isChecked);
            event.target.value = value;
            onClick(event);
        }
    };

    const getClasses = () => {
        if (disabled) {
            return 'radio-disabled';
        } else {
            return 'radio-default';
        }
    };

    const renderIcon = () => {
        if (isChecked) {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <mask id="mask0_278_22091" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                        <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_278_22091)">
                        <path d="M12 17.5C13.3833 17.5 14.5625 17.0125 15.5375 16.0375C16.5125 15.0625 17 13.8833 17 12.5C17 11.1167 16.5125 9.9375 15.5375 8.9625C14.5625 7.9875 13.3833 7.5 12 7.5C10.6167 7.5 9.4375 7.9875 8.4625 8.9625C7.4875 9.9375 7 11.1167 7 12.5C7 13.8833 7.4875 15.0625 8.4625 16.0375C9.4375 17.0125 10.6167 17.5 12 17.5ZM12 22.5C10.6167 22.5 9.31667 22.2375 8.1 21.7125C6.88333 21.1875 5.825 20.475 4.925 19.575C4.025 18.675 3.3125 17.6167 2.7875 16.4C2.2625 15.1833 2 13.8833 2 12.5C2 11.1167 2.2625 9.81667 2.7875 8.6C3.3125 7.38333 4.025 6.325 4.925 5.425C5.825 4.525 6.88333 3.8125 8.1 3.2875C9.31667 2.7625 10.6167 2.5 12 2.5C13.3833 2.5 14.6833 2.7625 15.9 3.2875C17.1167 3.8125 18.175 4.525 19.075 5.425C19.975 6.325 20.6875 7.38333 21.2125 8.6C21.7375 9.81667 22 11.1167 22 12.5C22 13.8833 21.7375 15.1833 21.2125 16.4C20.6875 17.6167 19.975 18.675 19.075 19.575C18.175 20.475 17.1167 21.1875 15.9 21.7125C14.6833 22.2375 13.3833 22.5 12 22.5ZM12 20.5C14.2333 20.5 16.125 19.725 17.675 18.175C19.225 16.625 20 14.7333 20 12.5C20 10.2667 19.225 8.375 17.675 6.825C16.125 5.275 14.2333 4.5 12 4.5C9.76667 4.5 7.875 5.275 6.325 6.825C4.775 8.375 4 10.2667 4 12.5C4 14.7333 4.775 16.625 6.325 18.175C7.875 19.725 9.76667 20.5 12 20.5Z" fill="#5B61A1" />
                    </g>
                </svg>
            );
        }

        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <mask id="mask0_278_22094" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                    <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_278_22094)">
                    <path d="M12 22.5C10.6167 22.5 9.31667 22.2375 8.1 21.7125C6.88333 21.1875 5.825 20.475 4.925 19.575C4.025 18.675 3.3125 17.6167 2.7875 16.4C2.2625 15.1833 2 13.8833 2 12.5C2 11.1167 2.2625 9.81667 2.7875 8.6C3.3125 7.38333 4.025 6.325 4.925 5.425C5.825 4.525 6.88333 3.8125 8.1 3.2875C9.31667 2.7625 10.6167 2.5 12 2.5C13.3833 2.5 14.6833 2.7625 15.9 3.2875C17.1167 3.8125 18.175 4.525 19.075 5.425C19.975 6.325 20.6875 7.38333 21.2125 8.6C21.7375 9.81667 22 11.1167 22 12.5C22 13.8833 21.7375 15.1833 21.2125 16.4C20.6875 17.6167 19.975 18.675 19.075 19.575C18.175 20.475 17.1167 21.1875 15.9 21.7125C14.6833 22.2375 13.3833 22.5 12 22.5ZM12 20.5C14.2333 20.5 16.125 19.725 17.675 18.175C19.225 16.625 20 14.7333 20 12.5C20 10.2667 19.225 8.375 17.675 6.825C16.125 5.275 14.2333 4.5 12 4.5C9.76667 4.5 7.875 5.275 6.325 6.825C4.775 8.375 4 10.2667 4 12.5C4 14.7333 4.775 16.625 6.325 18.175C7.875 19.725 9.76667 20.5 12 20.5Z" fill="#D9D9D9" />
                </g>
            </svg>
        );
    };

    return (
        <label className={`radio ${getClasses()}`} tabIndex="0" onKeyDown={handleKeyPress} {...props}>
            <div className="radio__icon">
                {renderIcon()}
            </div>
            <input
                type="radio"
                checked={isChecked}
                disabled={disabled}
                // onChange={onChange}
                onClick={onChange}
                readOnly
                value={value}
                className="radio__input"
                tabIndex="-1"
            />
            {label ? <span className="radio__label">{label}</span> : null}
        </label>
    );
};

Radio.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
    ]),
    disabled: PropTypes.bool
};

Radio.defaultProps = {
    disabled: false
};

export default Radio;
